/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modal-minhas-listas-replace{padding:16px}.modal-minhas-listas-replace__close{position:absolute;right:0;top:0;padding:8px;cursor:pointer}@media (max-width:380px){.modal-replace .modal-content{width:100%;max-height:100%;margin:0;border:none}}"];
export { styles as styles };
